import { typeFilterOptions, openOrdersFilterOptions } from "../apps/admin/maintenanceReports/utils/typeFilterOptions";
import { reportsList } from "../apps/admin/maintenanceReports/utils/reportsList";
import { cron, titleize, priorityList, timeFrames } from 'utils';
import { statusFilterOptions } from "../apps/admin/maintenanceReports/utils/statusFilterOptions";

let ordersTabs = [{ displayName: 'Unassigned', id: 'unassigned' }, { displayName: 'Assigned', id: 'assigned' }, { displayName: 'Completed', id: 'completed' }, { displayName: 'Canceled', id: 'cancelled' }, { displayName: 'Recurring', id: 'recurring' }];
let inspectionsTabs = [{ displayName: 'Open', id: 'open' }, { displayName: 'Completed', id: 'completed' }, { displayName: 'Cancelled', id: 'cancelled' }, { displayName: 'Recurring', id: 'recurring' }];

export const getReportType = ({ report }) => {
  if (inspectionsTabs.map(tab => `inspections_${tab.id}`).includes(report)) {
    return { page: 'inspections' }
  }
  if (report === 'make_ready') {
    return { page: 'make_ready' }
  }
  if (ordersTabs.map(tab => `orders_${tab.id}`).includes(report)) {
    return { page: 'orders' }
  }
  if (report.includes('vendors')) {
    return { page: 'vendors' }
  }
  if (report?.includes('techs')) {
    return { page: 'techs' }
  }
  if (report?.includes('units_breakdown')) {
    return { page: 'units_breakdown' }
  }

  let page = '';
  let selectedReportId = '';
  let selectedReportVariant = '';

  reportsList.map(r => {
    if (report.startsWith(r?.id)) {
      page = 'reports';
      selectedReportId = r.id;
      if (r?.variants?.length > 0) {
        selectedReportVariant = report.replace(`${r.id}_`, '');
      }
    }
  })

  return { page, selectedReportId, selectedReportVariant }
}

export const getDisplayFilters = ({ report }) => {

  let { page, selectedReportId, selectedReportVariant } = getReportType({ report });
  if (page === 'units_breakdown') {
    return [
      'property_ids',
      'date',
      'categories',
      'tabs',
    ]
  }
  if (page === 'inspections') {
    return [
      'property_ids',
      'date',
      'tabs',
      'templates'
    ]
  }
  if (page === 'reports') {
    let displayFilters = ['property_ids'];


    if ((selectedReportId === 'aging_work_orders' && selectedReportVariant === 'closed') ||
      selectedReportId === 'completed_work_orders' || selectedReportId === 'parts_pending' ||
      selectedReportId === 'cancelled_work_orders' || selectedReportId === 'work_order_by_level' ||
      selectedReportId === 'work_order_category' || selectedReportId === 'work_order_time' ||
      selectedReportId === 'tech_tips' || selectedReportId === 'inspections_status' ||
      selectedReportId === 'make_ready_metrics' || selectedReportId === 'make_ready_task_details' ||
      selectedReportId === 'tech_callback' || selectedReportId === 'ratings_and_reviews' || selectedReportId === 'response_time' ||
      (selectedReportId === 'open_work_order_status' && selectedReportVariant === 'detail')) {
      displayFilters.push('date');
    }

    if (selectedReportId === 'aging_work_orders') {
      displayFilters.push('aging');
    }

    if (selectedReportId === 'work_order_by_role' || selectedReportId === 'work_order_category' || selectedReportId === 'inspections_status') {
      displayFilters.push('report_status');
    }

    if (selectedReportId === 'make_ready_task_details' || selectedReportId === 'ratings_and_reviews') {
      displayFilters.push('persons');
    }

    if (selectedReportId === 'ratings_and_reviews') {
      displayFilters.push('residents');
    }

    if (selectedReportId === 'completed_work_orders' || selectedReportId === 'work_order_category' ||
      selectedReportId === 'parts_pending' || selectedReportId === 'cancelled_work_orders' || selectedReportId === 'average_completion_time' ||
      selectedReportId === 'work_order_time' || selectedReportId === 'open_work_order_status' || selectedReportId === 'response_time') {
      displayFilters.push('report_type');
    }

    if (selectedReportId === 'work_order_time' && selectedReportVariant === 'order' ||
      selectedReportId === 'response_time' && selectedReportVariant === 'tech' ||
      selectedReportId === 'open_work_order_status' && selectedReportVariant === 'detail') {
      displayFilters.push('techs')
    }

    if (selectedReportId === 'inspections_status') {
      displayFilters.push('report_template')
    }

    if (selectedReportId === 'make_ready_task_details' || selectedReportId === 'work_order_time') {
      displayFilters.push('report_completion')
    }

    if (selectedReportId === 'ratings_and_reviews') {
      displayFilters.push('report_ratings');
    }

    if (selectedReportId === 'response_time') {
      displayFilters.push('time_frame');
    }

    if (selectedReportId === 'response_time') {
      displayFilters.push('priority');
    }

    if (selectedReportId === 'response_time') {
      displayFilters.push('business_days');
    }

    if (selectedReportId === 'response_time') {
      displayFilters.push('exclusions');
    }

    if (selectedReportId === 'response_time') {
      displayFilters.push('open_orders');
    }

    return displayFilters;
  }

  if (page === 'make_ready') {
    return [
      'property_ids',
      'tabs',
      'floor_plans',
      'tags',
    ]
  }
  if (page === 'techs') {
    return [
      'property_ids',
      'date',
      'active',
    ]
  }
  if (page === 'vendors') {
    return [
      'property_ids',
      'date',
      'active',
    ]
  }
  if (page === 'orders') {
    return [
      'property_ids',
      'date',
      'priority',
      'waiting_on_parts',
      'no_access',
      'is_callback',
      'units',
      'categories',
      'tabs',
      'active_orders',
      'post_errors_only'
    ]
  }
}

export const populateModalFromSubscription = ({ subscription }) => {

  let tabs = [];

  if (subscription.report.includes('units_breakdown')) {
    tabs = [{ id: 'all', displayName: 'All', image: null, icon: null }, { id: 'open', displayName: 'Open', image: null, icon: null }, { id: 'closed', displayName: 'Closed', image: null, icon: null }];
  }

  if (subscription.report.includes('inspections')) {
    tabs = inspectionsTabs;
  }

  if (subscription.report.includes('make_ready')) {
    tabs = [{ displayName: 'Total', id: 'all', }, { displayName: 'On Notice', id: 'notice', }, { displayName: 'Total Vacant', id: 'vacant', }, { displayName: 'Vacant Not Ready', id: 'vacant_not_ready', }, { displayName: 'Vacant Ready', id: 'vacant_ready', }, { displayName: 'Archived', id: 'archived' }]
  }

  if (subscription.report.includes('orders')) {
    tabs = ordersTabs;
  }

  let { frequency, occurrenceValues, minute, hour, ampm } = cron.getFrequencyFromCron(subscription.cron_expression);

  let modalData = {
    report: subscription.report,
    title: subscription.name,
    selectedTimeSpan: subscription.time_frame,
    selectedCategoryIds: subscription.filters?.category_ids ?? [],
    property_ids: subscription.property_ids ?? [],
    selectedTab: subscription.filters?.status ?? '',
    active: subscription.filters?.active,
    tabs,
    waitingOnParts: subscription.filters?.waiting_on_parts,
    selectedPriorities: subscription.filters?.priority_ids ?? [],
    postErrorOrders: subscription.filters?.post_error,
    isNoAccess: subscription.filters?.no_access,
    isCallback: subscription.filters?.is_callback,
    selectedUnitIds: subscription.filters?.unit_ids ?? [],
    activeOrders: subscription.filters?.active_orders,
    selectedPersonIds: subscription.filters?.person_ids ?? [],
    selectedResidentIds: subscription.filters?.resident_ids ?? [],
    businessDaysOnly: subscription.filters?.business_days_only,
    selectedTimeFrames: subscription.filters?.completion_time_frame,
    selectedCompletionStatus: subscription?.filters?.completion_status,
    selectedTechIds: subscription.filters?.tech_ids,
    selectedRating: subscription.filters.rating,
    selectedTemplateIds: subscription.filters?.template_ids ?? [],
    selectedExclusionIds: subscription.filters?.exclusions ?? [],
    selectedOpenOrdersFilter: subscription.filters?.open_orders,
    selectedReportType: subscription.filters?.type,
    moveOutDate: subscription.filters?.has_move_out_date,
    moveInDate: subscription.filters?.has_move_in_date,
    selectedFloorplanIds: subscription.filters?.floor_plan_ids ?? [],
    selectedTagIds: subscription.filters?.tag_ids ?? [],
    ...getReportType({ report: subscription.report }),
    displayFilters: getDisplayFilters({ report: subscription.report }),
    format: subscription.format,
    frequency,
    occurrenceValues,
    minute: minute.toString(),
    hour: hour.toString(),
    ampm,
  };

  return modalData;
}

export const getDisplayRowFilters = ({ subscription, properties, categories, units, priorities, templates, persons, residents, techs, floorPlans, makeReadyCategories }) => {

  let filters = [];
  let displayFilters = getDisplayFilters({ report: subscription.report });
  let { page, selectedReportId, selectedReportVariant } = getReportType({ report: subscription.report });
  displayFilters.map(filter => {
    {
      if (filter === 'property_ids' && subscription.property_ids?.length > 0) {
        filters.push({
          display: 'PROPERTIES: ',
          value: properties.find(p => p.id === subscription.property_ids[0])?.name,
          count: subscription.property_ids.length - 1,
          type: 'array'
        })
      }

      if (filter === 'date' && subscription.property_ids?.length > 0) {
        filters.push({
          display: 'TIME FRAME: ',
          value: timeFrames.find(t => t.id === subscription?.time_frame)?.displayName ?? '',
          type: 'string'
        })
      }

      if (filter === 'categories' && subscription.filters?.category_ids?.length > 0) {

        let entries = [];
        categories?.map(c => {
          c.children.map(c => entries.push({ id: c.id, displayName: c.name, image: null, icon: null }))
        }) ?? [];

        filters.push({
          display: 'CATEGORIES: ',
          value: entries.find(c => c.id === subscription.filters?.category_ids[0])?.displayName ?? '',
          count: subscription.filters?.category_ids?.length - 1,
          type: 'array'
        })
      }

      if (filter === 'tabs' && subscription.filters?.status) {
        filters.push({
          display: 'STATUS: ',
          value: titleize(subscription.filters?.status),
          type: 'string'
        })
      }

      if (filter === 'active_orders' && subscription.filters?.active_orders) {
        filters.push({
          display: '',
          value: 'Active Orders',
          type: 'boolean'
        })
      }

      if (filter === 'no_access' && subscription.filters?.no_access) {
        filters.push({
          display: '',
          value: 'No Access',
          type: 'boolean'
        })
      }

      if (filter === 'is_callback' && subscription.filters?.is_callback) {
        filters.push({
          display: '',
          value: 'Is callback',
          type: 'boolean'
        })
      }

      if (filter === 'waiting_on_parts' && subscription.filters?.waiting_on_parts) {
        filters.push({
          display: '',
          value: 'Waiting on parts',
          type: 'boolean'
        })
      }

      if (filter === 'exclusions' && subscription.filters?.exclusions) {
        let entries = [{ id: 'awaiting_parts', displayName: 'Waiting on parts' }, { id: 'vendor', displayName: 'Assigned to vendor' }, { id: 'no_access', displayName: 'No access' }]
        filters.push({
          display: 'EXCLUSIONS: ',
          value: entries.find(c => c.id === subscription.filters?.exclusions[0])?.displayName ?? '',
          count: subscription.filters?.exclusions?.length - 1,
          type: 'array'
        })
      }

      if (filter === 'open_orders' && subscription.filters?.open_orders) {
        let options = openOrdersFilterOptions;
        let selectedOptionId = subscription.filters?.open_orders;

        if (options?.find(o => o.id === selectedOptionId)) {
          filters.push({
            display: 'OPEN WORK ORDERS: ',
            value: options.find(o => o.id === selectedOptionId)?.display,
            type: 'string'
          })
        }
      }

      if (filter === 'move_out' && subscription.filters?.has_move_out_date) {
        filters.push({
          display: '',
          value: 'Move out date',
          type: 'boolean'
        })
      }

      if (filter === 'move_in' && subscription.filters?.has_move_in_date) {
        filters.push({
          display: '',
          value: 'Move in date',
          type: 'boolean'
        })
      }

      if (filter === 'floor_plans' && subscription.filters?.floor_plan_ids?.length > 0) {
        filters.push({
          display: 'Floor plans: ',
          value: floorPlans.find(u => u.id === subscription.filters?.floor_plan_ids[0])?.name ?? '',
          count: subscription.filters?.floor_plans?.length - 1,
          type: 'array'
        })
      }

      if (filter === 'template_ids' && subscription.filters?.template_ids?.length > 0) {
        filters.push({
          display: 'Templates: ',
          value: templates.find(u => u.id === subscription.filters?.template_ids[0])?.name ?? '',
          count: subscription.filters?.template_ids?.length - 1,
          type: 'array'
        })
      }

      if (filter === 'tags' && subscription.filters?.tag_ids?.length > 0) {
        let categories = makeReadyCategories.filter(m => m.type === 'tags' && m.active);
        categories.map(c => {
          if (c.tags.map(t => t.id).some(id => subscription.filters?.tag_ids.includes(id))) {
            filters.push({
              display: `${c.name}: `,
              value: c.tags.find(u => u.id === subscription.filters?.tag_ids.filter(id => c.tags.map(t => t.id).includes(id))[0])?.name ?? '',
              count: subscription.filters?.tag_ids?.filter(id => c.tags.map(t => t.id).includes(id))?.length - 1,
              type: 'array'
            })
          }
        })

      }

      if (filter === 'post_errors_only' && subscription.filters?.post_error) {
        filters.push({
          display: '',
          value: 'Post errors only',
          type: 'boolean'
        })
      }

      if (filter === 'units' && subscription.filters?.unit_ids?.length > 0) {
        filters.push({
          display: 'UNITS: ',
          value: units.find(u => u.id === subscription.filters?.unit_ids[0])?.number ?? '',
          count: subscription.filters?.unit_ids?.length - 1,
          type: 'array'
        })
      }

      if (filter === 'priority' && subscription.filters?.priority_ids?.length > 0) {
        filters.push({
          display: 'PRIORITY: ',
          value: priorities.find(p => p.id === subscription.filters?.priority_ids[0])?.name ?? '',
          count: subscription.filters?.priority_ids?.length - 1,
          type: 'array'
        })
      }

      if (filter === 'active' && subscription.filters?.active) {
        filters.push({
          display: '',
          value: 'Active',
          type: 'boolean'
        })
      }

      if (filter === 'aging' && selectedReportVariant) {
        filters.push({
          display: 'AGING: ',
          value: titleize(selectedReportVariant),
          type: 'string'
        })
      }

      if (filter === 'report_type') {

        let options = typeFilterOptions[selectedReportId];

        let selectedOptionId = ['work_order_time', 'average_completion_time', 'completed_work_orders', 'parts_pending', 'cancelled_work_orders', 'response_time', 'open_work_order_status'].includes(selectedReportId) ? selectedReportVariant : subscription.filters?.type;
        if (options.find(o => o.id === selectedOptionId)) {
          filters.push({
            display: 'TYPE: ',
            value: options.find(o => o.id === selectedOptionId)?.display,
            type: 'string'
          })
        }
      }

      if (filter === 'report_template' && subscription.filters?.template_ids?.length > 0) {
        filters.push({
          display: 'TEMPLATE: ',
          value: templates.find(t => t.id === subscription.filters?.template_ids[0])?.name ?? '',
          count: subscription.filters?.template_ids?.length - 1,
          type: 'array'
        })
      }

      if (filter === 'report_status' && selectedReportVariant) {
        let options = statusFilterOptions[selectedReportId]?.map(o => ({ id: o.id, displayName: o.display, image: null, icon: null })) ?? statusFilterOptions['default']?.map(o => ({ id: o.id, displayName: o.display, image: null, icon: null }))

        filters.push({
          display: 'STATUS: ',
          value: options.find(o => o.id === selectedReportVariant)?.displayName ?? '',
          type: 'string'
        })
      }

      if (filter === 'persons' && subscription.filters?.person_ids?.length > 0) {

        filters.push({
          display: 'PERSONS: ',
          value: persons.find(t => t.person_id === subscription.filters?.person_ids[0])?.name ?? '',
          count: subscription.filters?.person_ids?.length - 1,
          type: 'array'
        })
      }

      if (filter === 'report_completion' && subscription?.filters?.completion_status) {
        let options = [
          { displayName: 'All', id: 'all' },
          { displayName: 'Completed', id: 'completed' },
          { displayName: 'Not Completed', id: 'not_completed' }
        ]
        filters.push({
          display: 'STATUS: ',
          value: options.find(o => o.id === subscription?.filters?.completion_status)?.displayName ?? '',
          type: 'string'
        })
      }

      if (filter === 'residents' && subscription.filters?.resident_ids?.length > 0) {
        filters.push({
          display: 'RESIDENTS: ',
          value: residents.find(t => t.id === subscription.filters?.resident_ids[0])?.name ?? '',
          count: subscription.filters?.resident_ids?.length - 1,
          type: 'array'
        })
      }

      if (filter === 'techs' && subscription.filters?.tech_ids?.length > 0) {
        filters.push({
          display: 'TECHS: ',
          value: techs.find(t => t.id === subscription.filters?.tech_ids[0])?.name ?? '',
          count: subscription.filters?.tech_ids?.length - 1,
          type: 'array'
        })
      }

      if (filter === 'report_ratings' && subscription?.filters?.rating) {
        filters.push({
          display: 'RATING: ',
          value: subscription?.filters?.rating.toString(),
          type: 'string'
        })
      }

      if (filter === 'business_days' && subscription.filters?.business_days_only) {
        filters.push({
          display: '',
          value: 'Business days only',
          type: 'boolean'
        })
      }
    }
  })
  return filters;
}